import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorRamSSDCapacity,
  fetchProcessorSSDCapacity,
  fetchProcessorSSDCapacityById,
  updateProcessorSSDCapacity,
  updateStatusInProcessorSSDCapcity,
} from "./thunk";

interface CategoryState {
  processor_ssd_capacity_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_ssd_capacity_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "ssd_capacity",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorSSDCapacity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorSSDCapacity.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_ssd_capacity_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorSSDCapacity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Processor Threads";
      })
      .addCase(fetchProcessorSSDCapacityById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorSSDCapacityById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorSSDCapacityById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorRamSSDCapacity.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_ssd_capacity_list = state.processor_ssd_capacity_list.map((ram_capacity) =>
          ram_capacity.id === action.payload.id ? action.payload : ram_capacity
        );
      })
      .addCase(addProcessorRamSSDCapacity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProcessorSSDCapacity.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_ssd_capacity_list = state.processor_ssd_capacity_list.map((ram_capacity) =>
          ram_capacity.id === action.payload.id ? action.payload : ram_capacity
        );
      })
      .addCase(updateProcessorSSDCapacity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInProcessorSSDCapcity.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorSSDCapcity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
